import { ethers } from "ethers";
import BaseContract from "./BaseContract";
import config from "../config";
import beekeeperabi from "../abis/beekeeper.json";

interface BeeKeeperContract {
  claimHoneyComb(
    hiveIds: number[],
    quantities: number[],
    rarity: number,
    leafs: string[],
    merkleProofs: string[][]
  ): Promise<ethers.ContractTransaction>;
  getClaimedCombPerHive(hiveId: number): Promise<number>;
}

class BeeKeeper extends BaseContract implements BeeKeeperContract {
  constructor(signerOrProvider: ethers.Signer | ethers.providers.Provider) {
    super(config.beekeeperProxyAddress, beekeeperabi, signerOrProvider )
  }

  async claimHoneyComb(
    hiveIds: number[],
    quantities: number[],
    rarity: number,
    leafs: string[],
    merkleProofs: string[][]
  ): Promise<ethers.ContractTransaction> {
    return this.callFunction("claimHoneyComb", [hiveIds, quantities, rarity, leafs, merkleProofs]);
  }


  async getClaimedCombPerHive(hiveId: number): Promise<number> {
    return this.contract.getClaimedCombsPerHive(hiveId);
  }
}

export default BeeKeeper;
